import { useEffect, useState } from "react"
import Button from "../../UI/Button/Button"
import Select from "../../UI/Select/Select"
import Input from "../../UI/Input/Input"
import fetchData from "../../../shared/fetchData";
import { checkValidity, updateObject } from "../../../shared/utility";
import { Row } from "reactstrap"

const DecreaseCredit = (props) => {

    const [decrease, setDecrease] = useState({
        amount: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'مبلغ کاهش اعتبار',
                unit: 'ریال'
            },
            validation: {
                required: true
            },
            errorMessage: 'فیلد الزامی است',
            valid: true,
            value: ''
        },
        comment: {
            elementType: 'input',
            elementConfig: {
                type: 'textarea',
                placeholder: 'توضیحات'
            },
            validation: {
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    });
    const [decreaseReason, setDecreaseReason] = useState('');
    const [decreaseValid, setDecreaseValid] = useState(true);
    const [decreaseReasons, setDecreaseReasons] = useState([]);

    useEffect(() => {
        var info = {
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/units/getDecreaseReasons'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                setDecreaseReasons(result.creditChangeTypes)
            })
            .catch(error => console.log(error))
    }, [])
    let decreaseReasonList = []
    if (decreaseReasons != null && decreaseReasons.length != 0) {
        decreaseReasons.map(b => {
            decreaseReasonList.push({
                value: b.id,
                label: b.description
            })
        })
    }
    const inputChangedHandlerDecrease = (event, controlName) => {
        let val = controlName == 'amount' ? event.target.value.toString().replace(/[^0-9]/g, "") : event.target.value
        let value = controlName == 'amount' ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : val
        const updatedControls = updateObject(decrease, {
            [controlName]: updateObject(decrease[controlName], {
                value: value,
                valid: checkValidity(event.target.value, decrease[controlName].validation)
            })
        });
        setDecrease(updatedControls);
    }
    const changeDecreaseReason = (selectedOption) => {
        setDecreaseReason(selectedOption)
    }
    const decreaseSubmit = (event) => {
        let dc = { ...decrease };
        let hasError = false
        for (let key in dc) {
            let element = { ...dc[key] }
            if (!checkValidity(dc[key].value, dc[key].validation)) {
                hasError = true
                element.valid = false
                dc[key] = element
            }
        }
        if (decreaseReason == '') {
            hasError = true
            setDecreaseValid(false)
        }
        if (hasError) {
            setDecrease(dc)
        } else {
            var info = {
                "unitId": props.unitId,
                "changeTypeId": decreaseReason.value,
                "comment": decrease.comment.value,
                "value": decrease.amount.value?.toString().replace(/[^0-9]/g, ""),
                "version": "mtpx001"
            }
            var raw = JSON.stringify(info)
            var url = 'management/api/v1/units/decreaseUnitBalanace'
            fetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == '0') {
                        props.reload();
                    }
                })
                .catch(error => console.log(error))
        }
    }
    const formElementsArrayD = [];
    for (let key in decrease) {
        formElementsArrayD.push({
            id: key,
            config: decrease[key]
        });
    }
    let formD = formElementsArrayD.map(formElement => {
        let className = '6 mt-3'
        if (formElement.id == 'comment') {
            className = '12 mt-3'
        }
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col={className}
                changed={(event) => inputChangedHandlerDecrease(event, formElement.id)} />
        );
    });
    const selectClassD = decreaseValid ? "SelectBox" : "InvalidSelect"
    return (
        <div>
            <div className="row justify-content-center">
                اطلاعات کاهش موجودی
            </div>
            <div className="col-12">
                <Row xs={2} >
                    <Select
                        name="form-field-name"
                        value={decreaseReason}
                        inModal={true}
                        placeholder="علت کاهش اعتبار"
                        options={decreaseReasonList}
                        onChange={changeDecreaseReason}
                        className={selectClassD}
                        col="6 mt-3"
                    />
                    {formD}
                </Row>
                <div className="row justify-content-center">
                    <Button btnType="Success" clicked={decreaseSubmit} >ثبت</Button>
                </div>
            </div>
        </div>
    )
}

export default DecreaseCredit;